<div>
  <div class="header-modal">
    <div>
      <span>Warning</span>
    </div>
    <div>
      <mat-icon class="pointer" [mat-dialog-close]="false">close</mat-icon>
    </div>
  </div>
  <div mat-dialog-content>{{ data }}</div>
  <div mat-dialog-actions>
    <button mat-stroked-button [mat-dialog-close]="true">OK</button>
    <button mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  </div>
</div>
